export default "__VITE_ASSET__DUSlnaos__"